<template>
  <div class="section-frame">
    <div class="section-frame__body">
      <div class="section-side">
        <nav class="section-nav" :aria-label="`${section.label} 메뉴`">
          <ul class="section-nav__list">
            <li v-for="item in visibleItems" :key="item.to" class="section-nav__item">
              <span
                v-if="item.disabled"
                class="section-nav__link is-disabled"
                :class="{ 'is-branch': hasCurrentChild(item) }"
              >
                {{ item.label }}
              </span>
              <router-link
                v-else
                :to="item.to"
                class="section-nav__link"
                :class="{ 'is-current': isCurrent(item), 'is-branch': hasCurrentChild(item) }"
              >
                {{ item.label }}
              </router-link>
              <ul v-if="item.children?.length" class="section-nav__sub">
                <li v-for="child in item.children" :key="child.to">
                  <router-link
                    :to="child.to"
                    class="section-nav__link section-nav__link--sub"
                    :class="{ 'is-current': isCurrent(child) }"
                  >
                    {{ child.label }}
                  </router-link>
                </li>
              </ul>
            </li>
          </ul>
        </nav>
        <SectionMallBanner />
      </div>
      <div class="section-frame__main">
        <slot />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import SectionMallBanner from '@/components/layout/SectionMallBanner.vue'
import { useAdminAuth } from '@/composables/useAdminAuth'
import {
  filterAdminOnlyNav,
  sideItemCurrent,
  type PortalSection,
  type PortalSideItem,
} from '@/constants/portalSections'

const props = defineProps<{ section: PortalSection }>()
const route = useRoute()
const { isAdminLoggedIn } = useAdminAuth()

const visibleItems = computed(() => filterAdminOnlyNav(props.section.items, isAdminLoggedIn.value))
const current = computed(() => sideItemCurrent(route.path, visibleItems.value))

function isCurrent(item: PortalSideItem) {
  return current.value === item
}

function hasCurrentChild(item: PortalSideItem) {
  return item.children?.some((child) => isCurrent(child)) ?? false
}
</script>

<style lang="scss" src="./SectionFrame.scss"></style>
